import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { BrandingAppInterface } from '@galaxy/partner';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { CustomizeApiService } from '../customize-api.service';

@Component({
  selector: 'app-product-names',
  templateUrl: './product-names.component.html',
  styleUrls: ['./product-names.component.scss'],
})
export class ProductNamesComponent implements OnInit {
  @Input()
  appNames: {
    [key: string]: BrandingAppInterface;
  };

  namesGroup: UntypedFormGroup;

  constructor(
    private customizeApi: CustomizeApiService,
    private formBuilder: UntypedFormBuilder,
    private snackbarService: SnackbarService,
    private translations: TranslateService,
  ) {}

  ngOnInit(): void {
    // Set them to empty string if they are the default name already.
    this.namesGroup = this.formBuilder.group({
      bcName: [this.appNames.VBC.name === 'Business App' ? '' : this.appNames.VBC.name],
      nbName: [this.appNames.NB.name === 'Brand Analytics' ? '' : this.appNames.NB.name],
    });
  }

  saveNames(): void {
    this.customizeApi
      .saveProductNames(this.namesGroup.get('bcName').value, this.namesGroup.get('nbName').value)
      .subscribe(
        () =>
          this.snackbarService.successSnack(this.translations.instant('CUSTOMIZE_PARTNER.PRODUCT_NAMES.FORM_SUCCESS')),
        (err) => {
          console.error(err);
          this.snackbarService.errorSnack(this.translations.instant('CUSTOMIZE_PARTNER.PRODUCT_NAMES.FORM_FAILURE'));
        },
      );
  }

  restoreDefault(): void {
    if (!confirm(this.translations.instant('CUSTOMIZE_PARTNER.SHARED.RESTORE_DEFAULT_CONFIRMATION'))) {
      return;
    }
    this.namesGroup.patchValue({
      bcName: '',
      nbName: '',
    });
    this.saveNames();
  }
}
